export { default } from './QuotationDetail' 


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationDetail/index.js